/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatalistAnagrafica, DocumentoManutenzione, DocumentoOpera, DocumentoProgetto } from '@models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';

@Component({
    selector: 'app-toolkit-modal-upload-documento',
    templateUrl: './modal-upload-documento.component.html',
})
export class ToolkitGestioneOperaModalUploadDocumentoComponent implements OnInit {
    
    @Input() azione: string;
    @Input() datalist: DatalistAnagrafica;
    @Input() params: DocumentoOpera | DocumentoProgetto | DocumentoManutenzione;

    public file: any;
    public criteriaForm: FormGroup;

    constructor(
        public activeModal: NgbActiveModal,
        private operaService: OperaService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.criteriaForm = this.fb.group({
            idDocumento: this.fb.control(null),
            idClasseDocumento: this.fb.control(null, Validators.required),
            idOpera: this.fb.control(this.operaService.operaSession.idOpera, Validators.required),
            didascalia: this.fb.control(null, Validators.required),
            docPublic: this.fb.control(1, Validators.required)
            
        });
        if (this.params) {
            this.file = 'file';
            this.criteriaForm.patchValue(this.params);
        }
    }

    public save() {
        this.activeModal.close({
            form: this.criteriaForm,
            file: this.file,
        });
    }

    public setFile(file: any) {
        this.file = file;
    }

}
